import React from 'react';
import { Card } from '@therms/atalaya';

export const Details = (props) => {
  const details =
    props.rpcScopeProcedure.allProceduresByScope[props.params.scope][
      props.params.procedure
    ][props.params.version - 1].description;

  return (
    <Card>
      <div className="text-lg font-bold">Description</div>
      <div>{details}</div>
    </Card>
  );
};
